import type { EventPropertyType } from "@redotech/redo-model/external-apis/custom-events/create-custom-event";
import { createContext } from "react";

export interface PropertyInfo {
  key: string;
  type: EventPropertyType;
}

// Maps event name to its array of segmentable properties with type info
export const CustomEventPropertyKeysContext = createContext<
  Map<string, PropertyInfo[]>
>(new Map());

export { type EventPropertyType } from "@redotech/redo-model/external-apis/custom-events/create-custom-event";
